module.exports = "fragment StripeOrderFragment on StripeOrder {\n  __typename\n  id\n  total\n  subtotal\n  discount\n  shipping\n  tax\n}\n"